<script>
import Layout from "./main";
import PageHeader from "@/components/page-header";
import LayoutList from "./list";
import {toPlural} from "@/helpers/utils";

export default {
  props: {
    resourceName: {
      type: String,
      required: true
    },
    ressourceDefaultFields: {
      type: Object
    },
    listFields: {
      type: Array
    },
    sortBy: {
      type: String,
      default: 'id'
    },
    sortDesc: {
      type: Boolean,
      default: true
    },
    listProviderFields: {
      type: Object
    },
    withHeader: {
      type: Boolean,
      default: true
    },
    withFooter: {
      type: Boolean,
      default: true
    },
    withAdvancedSearch: {
      type: Boolean,
      default: false
    },
    updateListe: {
      type: Boolean,
      default: false
    },
    reloadResourceOnShow: {
      type: Boolean,
      default: false
    },
    reloadResourceOnEdit: {
      type: Boolean,
      default: false
    },
    reloadResourceParameters: {
      type: Object
    },
    addButton: {
      type: Boolean,
      default: true
    },
    canDeleteResource: {
      type: Boolean,
      default: true
    },
    canEditResource: {
      type: Boolean,
      default: true
    },
    canShowResource: {
      type: Boolean,
      default: true
    },
  },
  components: {
    LayoutList,
    Layout,
    PageHeader,
  },
  data() {
    return {
      localResourceNamePlur: toPlural(this.resourceName),
      title: '',
      items: [],
      selectedResource: null,
      showEditForm: false,
      localUpdateList: this.updateListe,
      layoutListKey: 'layoutList' + this.resourceName + '_' + Date.now()
    };
  },
  computed: {
    loadComponentForm() {
      return () => import(`../../components/${this.localResourceNamePlur}/${this.resourceName}-form`);
    }
  },
  watch: {
    updateListe: function (newVal) {
      if (newVal)
        this.reloadComponentLayoutList();
    }
  },
  mounted() {
    this.title = this.$t(`general.${this.localResourceNamePlur}`);
    this.items = [
      {
        text: this.title,
        active: true
      },
      {
        text: this.$t('general.list'),
        active: true
      }
    ];
  },
  methods: {
    reloadComponentLayoutList() {
      this.layoutListKey = 'layoutList' + this.resourceName + '_' + Date.now();
      this.$emit('updated');
    },
    hideModal() {
      this.selectedResource = null;
      this.showEditForm = false;
      this.reloadComponentLayoutList();
    },
    toCellName(slot) {
      return `cell(${slot})`
    },
    lauchNewForm() {
      this.selectedResource = {};
      Object.assign(this.selectedResource, this.ressourceDefaultFields);
      this.showEditForm=true;
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <b-row class="mb-2">
      <b-col></b-col>
      <b-col v-if="addButton">
        <b-button variant="primary" class="btn-label float-end text-capitalize"
                  @click="lauchNewForm">
          <i class="bx bx-plus label-icon"></i> {{ $t(`general.${this.resourceName}`) }}
        </b-button>
      </b-col>
    </b-row>

    <b-card no-body>
      <b-card-body>
        <layout-list
            :key="layoutListKey"
            :resource-name="resourceName"
            :fields="listFields"
            :list-provider-fields="listProviderFields"
            :update-liste="localUpdateList"
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            :reload-resource-parameters="reloadResourceParameters"
            :reload-resource-on-show="reloadResourceOnShow"
            :reload-resource-on-edit="reloadResourceOnEdit"
            :with-header="withHeader"
            :with-footer="withFooter"
            :with-advanced-search="withAdvancedSearch"
            :can-delete-resource="canDeleteResource"
            :can-edit-resource="canEditResource"
            :can-show-resource="canShowResource"
        >
          <template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="data">
            <slot :name="slot" v-bind="data"/>
          </template>
        </layout-list>
      </b-card-body>
    </b-card>


    <b-modal id="modal-edit" :title-html="$t(`general.${this.resourceName}`)" centered hide-footer
             size="xl"
             title-class="font-18"
             v-model="showEditForm">
      <component
          v-if="selectedResource"
          :is="loadComponentForm"
          :resource="selectedResource"
          @cancel="hideModal"
          @submitted="hideModal"
      ></component>
    </b-modal>
  </Layout>
</template>
